import PropTypes from 'prop-types';
import ConnectionAvatar from '../../../UISystem/ConnectionAvatar';
import { ButtonRounded } from '../../../UISystem/Buttons';
import { COLORS } from '../../../../styles/UISystem';
import { firstNameOf } from '../../../../utils/contactUtils';

/**
 * AnonLandingPage — the unified landing every QR scan opens (exchange-clarity
 * D1, revised at device pass 1, 2026-07-27 user mock): wordmark, host
 * identity, the one-line promise, black [Open chat]. The join door is REMOVED
 * until friends can go directly to sign up — the claim flow will ride the
 * existing whitelisted invite first (invite epic); the waitlist sheet was the
 * wrong destination for that line.
 *
 * View gate only: formation (markAnonConnected, confirms, WebSocket join) runs
 * underneath in AnonExchangeFlow — the dwell buys the Profile the head start
 * to speak first (D4). Mock: the 2026-07-27 user frame (supersedes
 * unified_anon_chat/anon_chat_1.png for copy, button, avatar size).
 */
const AnonLandingPage = ({ profileData, onOpenChat }) => {
  const firstName = firstNameOf(profileData?.name);

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: COLORS.WHITE,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* ROYALE wordmark — same treatment as the QR screen the scan came from */}
      <div
        style={{
          marginTop: 'calc(env(safe-area-inset-top) + 48px)',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
          fontSize: '18px',
          fontWeight: '900',
          letterSpacing: '4px',
          color: '#000000',
        }}
      >
        ROYALE
      </div>

      {/* Host identity + promise — centered in the remaining space */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ConnectionAvatar photoUrl={profileData?.photoUrl} name={profileData?.name} size={96} />
        <div
          style={{
            fontSize: '26px',
            fontWeight: '700',
            color: '#000000',
            marginTop: '24px',
          }}
        >
          {firstName ? `Chat with ${firstName}` : 'Chat'}
        </div>
        <div
          style={{
            fontSize: '17px',
            color: '#8E8E93',
            textAlign: 'center',
            lineHeight: 1.35,
            maxWidth: '300px',
            marginTop: '10px',
          }}
        >
          Swap name and contact
          <br />
          privately &mdash; no account needed
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: 'calc(48px + env(safe-area-inset-bottom))',
        }}
      >
        <ButtonRounded
          text="Open chat"
          onClick={onOpenChat}
          variant="primary"
          size="auto"
          style={{ minWidth: '170px' }}
        />
      </div>
    </div>
  );
};

AnonLandingPage.propTypes = {
  profileData: PropTypes.shape({
    name: PropTypes.string,
    photoUrl: PropTypes.string,
  }),
  onOpenChat: PropTypes.func.isRequired,
};

export default AnonLandingPage;
